import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { TopTitle } from '../components/atoms/TopTitle'
import { RegistrationForm } from '../components/forms/RegistrationForm'
import { useApp } from '../hooks/useApp'
import { callAxios } from '../hooks/useAxios'
import { RegistrationData } from '../types/auth'

export function RegisterPage(): React.ReactElement {

  const { t } = useTranslation()
  const navigate = useNavigate()

  const app = useApp()

  const onSubmit = (data: RegistrationData) => {
    callAxios({
      method: 'POST',
      url: '/auth/register',
    }, data).then(res => {
      if (res.success) {
        navigate('/login')
        app.addInfo(t('Registration was successful. Please check your email.'))
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <>
      <TopTitle title={t('Register Account')}/>
      <RegistrationForm onSubmit={onSubmit}/>
    </>
  )
}
